import React, { useRef, useState } from "react";
import { List } from "antd";
import {
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import styles from "./FinishedProcessParameters.module.css";
import { useLocation, useNavigate } from "react-router-dom";


const FinishedProcessParameters = () => {

    const navigate = useNavigate();
  
  const [finalTemperatureMixing, setFinalTemperatureMixing] = useState("");
  const [bakingTimeMixing, setBakingTimeMixing] = useState("");

  const [finalTemperatureMakeup, setFinalTemperatureMakeup] = useState("");
  const [bakingTimeMakeup, setBakingTimeMakeup] = useState("");

  const [finalTemperatureProof, setFinalTemperatureProof] = useState("");
  const [bakingTimeProof, setBakingTimeProof] = useState("");



  const [mixingImage, setMixingImage] = useState(null);

  const fileInputRef = useRef();

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setMixingImage(file);
    }
  };

  // const data = [
  //   {
  //     id: 1,
  //     title: "Mixing",
  //     components: [
  //       { label: "Sour Dough Mixing", type: "button" },
  //       { label: "Final Temperature", type: "input" },
  //       { label: "Baking Time", type: "input" },
  //       { label: "Upload Picture", type: "upload" },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     title: "Makeup",
  //     components: [
  //       { label: "Sour Dough Mixing", type: "button" },
  //       { label: "Final Temperature", type: "input" },
  //       { label: "Baking Time", type: "input" },
  //     ],
  //   },
  //   {
  //     id: 3,
  //     title: "Proof",
  //     components: [
  //       { label: "Sour Dough Mixing", type: "button" },
  //       { label: "Final Temperature", type: "input" },
  //       { label: "Baking Time", type: "input" },
  //     ],
  //   },
  // ];


   const data = [
    {
      id: 1,
      title: "Mixing",
      components: [
        { label: "Sour Dough Mixing", type: "button" },
        {
          label: "Final Temperature",
          type: "input",
          getter: finalTemperatureMixing,
          setter: setFinalTemperatureMixing,
        },
        {
          label: "Baking Time",
          type: "input",
          getter: bakingTimeMixing,
          setter: setBakingTimeMixing,
        },
        { label: "QC Check", type: "upload" },
      ],
    },
    {
      id: 2,
      title: "Makeup",
      components: [
        { label: "Sour Dough Mixing", type: "button" },
        {
          label: "Final Temperature",
          type: "input",
          getter: finalTemperatureMakeup,
          setter: setFinalTemperatureMakeup,
        },
        {
          label: "Baking Time",
          type: "input",
          getter: bakingTimeMakeup,
          setter: setBakingTimeMakeup,
        },
      ],
    },
    {
      id: 3,
      title: "Proof",
      components: [
        { label: "Sour Dough Mixing", type: "button" },
        {
          label: "Final Temperature",
          type: "input",
          getter: finalTemperatureProof,
          setter: setFinalTemperatureProof,
        },
        {
          label: "Baking Time",
          type: "input",
          getter: bakingTimeProof,
          setter: setBakingTimeProof,
        },
      ],
    },
  ];

  return (
    <div>
      <TextComponent text="Your Processes" className={styles.productHeading} />
  <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
        accept="image/*"
      />
      <List
        dataSource={data}
        renderItem={(process) => (
          <List.Item>
            <div className={styles.card}>
              <TextComponent text={process.title} className={styles.cardTitle} />

              {process.components.map((component, idx) => (
                <div key={idx} className={styles.paramRow}>
                  <TextComponent
                    text={component.label}
                    className={styles.paramText}
                  />

                  {component.type === "button" && (
                    <SubmitButton
                      title="View Process"
                      btnClass={styles.progBtn}
                      primary
                      btnContainerClass={styles.paramBtnContainer}
                      onClick={() =>navigate ("/ProductionManagement/ProcessManagement/InstructionSetup/Summary")}
                    />
                  )}

                  {component.type === "input" && (
                    <InputField
                      inputStyle={{ backgroundColor: "var(--white-color)" }}
                      className={styles.inputNew}
                      placeholder="45"
                      type="number"
                      // value={
                      //   component.label.includes("Baking")
                      //     ? bakingTime
                      //     : finalTemperature
                      // }
                      // onChange={(e) =>
                      //   component.label.includes("Baking")
                      //     ? setBakingTime(e.target.value)
                      //     : setFinalTemperature(e.target.value)
                      // }

                       value={component.getter}
                      onChange={(e) => component.setter(e.target.value)}
                    />
                  )}

                  {/* {component.type === "upload" && (
                    <div className={styles.uploadBox}>
                      <button className={styles.uploadBtn}>Upload Picture</button>
                    </div>
                  )} */}

                     {component.type === "upload" && (
                    <div className={styles.uploadBox}>
                      <button className={styles.uploadBtn} onClick={handleUploadClick}>
                        {mixingImage ? "Change Picture" : "Upload Picture"}
                      </button>
{/* 
                      {mixingImage && (
                        <div className={styles.fileName}>{mixingImage.name}</div>
                      )} */}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </List.Item>
        )}
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 2,
          lg: 3,
          xl: 3,
        }}
      />

    
    </div>
  );
};

export default FinishedProcessParameters;
